import { render, staticRenderFns } from "./Login_google.vue?vue&type=template&id=574af570"
import script from "./Login_google.vue?vue&type=script&lang=js"
export * from "./Login_google.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports